import PhotoSwipeLightbox from 'photoswipe/lightbox';
import Swiper, {Navigation, Thumbs, FreeMode} from "swiper";

$(document).ready(function () {
    galleryInit();
});

const galleryInit = () => {
    const gallery = '#gallery';
    const children = '.pswp-gallery__item';
    let deepZoomPlugin;
    let lightbox;

    const thumbSlider = new Swiper('.product-thumb-slider', {
        spaceBetween: 16,
        slidesPerView: 3,
        freeMode: true,
        direction: 'horizontal',
        watchSlidesProgress: true,
        effect: 'fade',

        fadeEffect: {
            crossFade: true
        },

        breakpoints: {
            991: {
                direction: 'vertical',
                slidesPerView: 4,
            },
        }
    });

    const mainSlider = new Swiper('.product-main-slider', {
        modules: [Navigation, Thumbs, FreeMode],
        spaceBetween: 10,
        freeMode: true,
        effect: 'fade',

        fadeEffect: {
            crossFade: true
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        thumbs: {
            swiper: thumbSlider,
        },

        on: {
            init: () => {
                lightbox = new PhotoSwipeLightbox({
                    pswpModule: () => import('photoswipe'),
                    children,
                    gallery,
                    spacing: 0.5,
                    zoom: false,
                    bgOpacity: 1,
                    wheelToZoom: true,
                    showAnimationDuration: 0,
                    showHideAnimationType: 'fade',
                    errorMsg: 'The photo cannot be loaded',

                    openPromise: () => {
                        if (!deepZoomPlugin) {
                            return import('photoswipe-deep-zoom-plugin').then((deepZoomPluginModule) => {
                                deepZoomPlugin = new deepZoomPluginModule.default(lightbox);
                            });
                        }
                    },
                });

                lightbox.init();
            },

            destroy: () => lightbox.destroy(),
        },

    });

    const photosTab = document.querySelector('#product-gallery-photos-tab');
    if (photosTab) {
        $(photosTab).on('shown.bs.tab', () => {
            thumbSlider.update();
            mainSlider.update();
        });
    }

    window.addEventListener('resize', function () {
        handleChangeSize(children);
    }, {passive: true});

    handleChangeSize(children);
}

const handleChangeSize = (item) => {
    $(item).attr('data-pswp-width', $(window).innerWidth());
    $(item).attr('data-pswp-height', $(window).innerHeight());
    $(item).attr('data-pswp-max-width', $(window).innerWidth());
    $(item).attr('data-pswp-max-height', $(window).innerHeight());
}




